import CtaJoinDynamic from './CtaJoinDynamic'

export default CtaJoinDynamic
// eslint-disable-next-line import/export
export * from './CtaJoinDynamic'
